import { JournalEntry } from './types';

export function assertNever(n: never): never {
  throw new Error(`assertNever ${n}`);
}

export function getBalance(group: Array<JournalEntry>): number {
  let balance = 0;
  for (const entry of group) {
    if (entry.creditAmount != null) {
      balance += entry.creditAmount;
    } else if (entry.debitAmount != null) {
      balance -= entry.debitAmount;
    }
  }
  return balance;
}
